// The Impressum publishes a trap local part instead of the real one. Harvesters that
// scrape the served HTML come away with `nospam@`, which forwards to the same inbox
// but marks the sender as a scraper; visitors with JS get the real local part swapped
// in here. The mapping therefore only ever lives in this bundle, never in the HTML.
const TRAP_LOCAL_PARTS: Record<string, string> = {
  nospam: "legal",
};

export const initCompanyDetailsEmailUnmask = () => {
  const companyDetails = document.getElementById("company-details");

  if (!companyDetails) {
    return;
  }

  const maskedEmails = companyDetails.querySelectorAll<HTMLElement>(".js-email-unmask");

  maskedEmails.forEach((maskedEmail) => {
    const masked = maskedEmail.textContent?.trim();

    if (masked) {
      for (const [trapLocalPart, realLocalPart] of Object.entries(TRAP_LOCAL_PARTS)) {
        if (masked.startsWith(`${trapLocalPart}@`)) {
          maskedEmail.textContent = `${realLocalPart}${masked.slice(trapLocalPart.length)}`;
          break;
        }
      }
    }

    // `invisible` rather than `d-none` in the template, so the hidden span still
    // reserves its line box and revealing it shifts no content. Revealed even when no
    // trap local part matched, so that a typo in the template can never leave the
    // Impressum with no contact address showing at all.
    maskedEmail.classList.remove("invisible");
  });
};
